/*
 * Copyright (C)  E-Synaps SAS - 2020 - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import api from '@/api/api'

export function search(term) {
  return api.post('/v2/professionals/medunion/search-establishment', {
    name: term
  })
}

export function get(uid) {
  return api.get(`/v2/medunion/establishments/${uid}`)
}

export function getFeedList(uid) {
  return api.get(`/v3/establishments/${uid}/feed-list`)
}
